document.addEventListener("DOMContentLoaded", function () {
  const czPath = "/pages/fry-trial";
  const bgUrl = "https://huuust.bg/pages/%D0%B1%D0%B5%D0%B7%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%BD-%D1%82%D0%B5%D1%81%D1%82-%D0%B7%D0%B0-%D0%BF%D1%8A%D1%80%D0%B6%D0%B5%D0%BD%D0%B5/";

  const infoBoxLinks = document.querySelectorAll(".info-box a");

  if (!infoBoxLinks.length) {
    console.warn("Huuust BG link replace: no .info-box links found.");
  } else {
    infoBoxLinks.forEach(function (link) {
      const rawHref = link.getAttribute("href") || "";
      const fullHref = link.href || "";

      const isFryTrialLink =
        rawHref.includes(czPath) ||
        fullHref.includes(czPath);

      if (isFryTrialLink) {
        link.setAttribute("href", bgUrl);
        console.log("Huuust BG link replace: changed link to BG URL", link);
      }
    });
  }

  document.querySelectorAll(".footer-link").forEach(function (link) {
    const rawHref = link.getAttribute("href") || "";

    console.log("Footer link found:", rawHref);

    if (
      rawHref === "https://www.huuust.cz/account" ||
      rawHref === "https://huuust.cz/account"
    ) {
      link.setAttribute("href", "/account");
      console.log("Huuust account link changed to relative /account", link);
    }
  });
});